import { Injectable } from '@angular/core';
import { AnalyticModalEventNames } from '../../store/analytic-modal-event-names';
import { CommonDialogState, CommonDialogStore } from '../../store/common-dialog.store';

@Injectable()
export class InfoDialogStore extends CommonDialogStore<CommonDialogState> {
  constructor() {
    super({ isDialogPositionUp: false }, { eventName: AnalyticModalEventNames.INFO_DIALOG });
  }
}
